import React, {Fragment} from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {Filter} from 'presentation/components/Filter';

import {useConsultRefundFilterDrawer} from './hooks/useConsultRefundFilterDrawer';

export function ConsultRefundFilterDrawer() {
	const {
		activeRefundFilterCount,
		applyFilters,
		clearFilterButton,
		filter,
		filters,
		handleClearFilters,
		handleSubmitFilters,
		listFilters,
		openDrawerState,
		setOpenDrawerState,
	} = useConsultRefundFilterDrawer();

	return (
		<Fragment>
			<Filter.Button
				type="button"
				onClick={() => setOpenDrawerState(true)}
				count={activeRefundFilterCount}>
				{filter}
			</Filter.Button>
			<Drawer.Root
				open={openDrawerState}
				onClose={() => setOpenDrawerState(false)}
				onOpen={() => null}>
				<Drawer.Header title={filters} onClose={() => setOpenDrawerState(false)} />
				<Drawer.ContentListByCategory categoryList={listFilters} />
				<Drawer.Footer
					firstButtonTitle={clearFilterButton}
					firstButtonOnClick={() => handleClearFilters()}
					secondButtonTitle={applyFilters}
					secondButtonOnClick={() => handleSubmitFilters()}
				/>
			</Drawer.Root>
		</Fragment>
	);
}
